import styled from 'styled-components'
import CopyField from '@components/CopyField'
import { Caption, Value } from '@components/CopyField/CopyField.styles'
import { HeadingTitle } from '@components/PageHeading/PageHeading.styles'
import { darkOrange, orange, textMuted, white } from '@/theme/colors'
import { media } from '@/theme/tokens'
import { fontSizes } from '@/theme/typography'
import { Button } from '@components/Button'

const phone = `${media.phone}`

/**
 * The iOS success screen inside the flow's card: a centred column with the
 * exit pinned below it — no header, no step indicator, no bottom bar.
 */
export const ReadyLayout = styled.div`
	flex: 1;
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 100%;
	max-width: 520px;
	margin: 0 auto;
	padding: 40px 24px 28px;

	${phone} {
		padding: 24px 14px 20px;
	}
`

export const ReadyCenter = styled.div`
	flex: 1;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	width: 100%;
	text-align: center;
`

export const CheckCircle = styled.div`
	width: 72px;
	height: 72px;
	border-radius: 50%;
	background: ${orange};
	color: ${white};
	display: flex;
	align-items: center;
	justify-content: center;
`

/** A long trip name wraps inside the column; an unbroken one breaks mid-word rather than overflowing. */
export const ReadyTitle = styled(HeadingTitle)`
	margin-top: 22px;
	text-align: center;
	max-width: 100%;
	overflow-wrap: anywhere;
`

/**
 * The screen's primary action. A trip with nobody in it is the thing to fix
 * here, so inviting carries the solid fill and the exit below is the quiet one.
 */
export const InviteButton = styled(Button).attrs({ size: 'lg' as const })`
	width: 100%;
	height: 52px;
	margin-top: 32px;
`

/**
 * The trip code as a quiet line under the invite button — no card, no fill, a
 * smaller face — so it reads as the fallback the invite dialog already offers,
 * not as a second call to action. Still one press to copy.
 */
export const CodeField = styled(CopyField)`
	width: auto;
	margin-top: 16px;
	padding: 0;
	border: none;
	background: transparent;
	gap: 10px;

	${Caption} {
		font-size: ${fontSizes.micro};
	}

	${Value} {
		font-size: ${fontSizes.base};
		color: ${textMuted};
	}
`

/** The exit, in the tonal treatment — available, not insistent. */
export const GoButton = styled(Button).attrs({ variant: 'tonal' as const })`
	width: 100%;
	height: 48px;
	margin-top: 40px;
	border-color: ${darkOrange}1f;
	font-size: ${fontSizes.base};

	${phone} {
		margin-top: 24px;
	}
`
